import ky from 'ky';

export default ky.extend({
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set('Accept-Language', 'th;q=0.9, en-US,en;q=0.8');
      },
    ],
  },
});
